import React from "react";
import HubTabs from "../../components/HubTabs";
import Dashboard from "../Dashboard";
import Reports from "../Reports";
import ChatMoments from "../Moments";
import { i18n } from "../../translate/i18n";

const tLang = (key, fallback) => {
  const v = i18n.t(key);
  return !v || v === key ? fallback : v;
};

const tabs = [
  {
    label: tLang("mainDrawer.listItems.dashboard", "Dashboard"),
    path: "/",
    Component: Dashboard,
  },
  {
    label: tLang("mainDrawer.listItems.reports", "Relatórios"),
    path: "/reports",
    Component: Reports,
  },
  {
    label: tLang("mainDrawer.listItems.chatsTempoReal", "Painel"),
    path: "/moments",
    Component: ChatMoments,
  },
];

const ManagementHub = () => <HubTabs tabs={tabs} />;

export default ManagementHub;
